import { AxiosResponse } from 'axios';

// Helper.
import API from '../Api';
import { logUserOut } from '../utils/login';
// Types.
import { HubSpotBlog } from '../types/news';

export const fetchNews = async (endpoint: string, limit: number): Promise<HubSpotBlog[]> => {
  if (!endpoint) {
    endpoint = 'anon';
  }

  const news: AxiosResponse<HubSpotBlog[]> = await API({
    method: 'post',
    url: `/v1/news/${endpoint}/${limit}`,
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        logUserOut();
      }
      return error.response;
    }
  });

  return news.data;
};
